(() => {
  const source = document.getElementById('rp-cookie-brand-copy');
  if (!source) return;
  const copy = JSON.parse(source.textContent);
  const decorate = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.rpBranded === 'true') return;
    const body = banner.querySelector('.shopify-pc__banner__body');
    const title = banner.querySelector('#shopify-pc__banner__body-title');
    const paragraph = body?.querySelector('p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!body || !title || !paragraph || !policy || !accept || !decline || !preferences) return;
    banner.dataset.rpBranded = 'true';
    const close = document.createElement('button');
    close.id = 'rp-cookie-close';
    close.type = 'button';
    close.setAttribute('aria-label', copy.close);
    close.title = copy.close;
    close.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3L13 13M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    close.addEventListener('click', () => { banner.style.display = 'none'; });
    banner.append(close);
    const logo = document.getElementById('rp-cookie-brand-logo');
    if (logo) body.prepend(logo.content.cloneNode(true));
    title.textContent = copy.title;
    const note = document.createElement('span');
    note.className = 'rp-cookie-note';
    note.textContent = copy.note;
    paragraph.replaceChildren(document.createTextNode(copy.description), note, policy);
    accept.textContent = copy.accept;
    decline.textContent = copy.decline;
    const label = preferences.querySelector('span') || preferences;
    label.textContent = copy.preferences;
    const buttons = accept.parentElement;
    buttons.append(decline, accept, preferences);
  };
  decorate();
  const observer = new MutationObserver((records) => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.querySelector?.('#shopify-pc__banner'))
    ))) decorate();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
